// operatoriApi.js
import apiClient from "./apiClient";

const operatoriAPI = {
  getAllOperatori: () => apiClient.get(`/company/operator/index?company_id=${localStorage.getItem('company_id')}`),
  createOperatori: (data) => apiClient.post(`/company/operator/store?company_id=${localStorage.getItem('company_id')}`, data),
  updateOperatori: (id, data) => apiClient.post(`/company/operator/update/${id}?company_id=${localStorage.getItem('company_id')}`, data),
  deleteOperatori: (id) => apiClient.delete(`/company/operator/delete/${id}?company_id=${localStorage.getItem('company_id')}`),
  getSingleOperatori: (id) => apiClient.get(`/company/operator/show/${id}?company_id=${localStorage.getItem('company_id')}`),
};

export default operatoriAPI;